.chartTitle {
  font-size: 12px;
  color: var(--brown-grey);
}

.gauges {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
}

.percentage {
  width: 176px;
  height: 112px;
  padding: 10px 6px;
  border-radius: 5px;
  margin-right: 10px;
  border: solid 1px var(--very-light-pink);
  display: flex;
  flex-direction: column;
}

.percentageTitle {
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  margin-bottom: 8px;
  color: var(--brown-grey);
}

.percentageCenter {
  display: flex;
  flex: 1;
}

.percentageImage {
  width: 52px;
  height: 52px;
  object-fit: contain;
  align-self: center;
}

.percentageText {
  font-size: 46px;
  font-weight: 300;
  margin: auto 0;
}

.percentageBar {
  background-color: #ebebeb;
  height: 8px;
  width: 170px;
}

.percentageBar div {
  height: 8px;
}

.healthRates {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 32px;
  row-gap: 12px;
}

.healthEmpty {
  margin-top: 8px;
  font-size: 14px;
  color: var(--brown-grey);
}

.healthHeadline {
  display: flex;
  flex-direction: column;
}

.healthLabel {
  font-size: 12px;
  font-weight: 500;
  color: var(--brown-grey);
  margin-bottom: 4px;
}

.healthHeadlineValue {
  font-size: 46px;
  font-weight: 300;
  line-height: 1;
}

.healthCounts {
  font-size: 12px;
  color: var(--brown-grey);
  margin-top: 6px;
}

.healthSecondary {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.healthSecondaryValue {
  font-size: 22px;
  font-weight: 300;
  line-height: 1;
  color: var(--black);
}

.healthTrends {
  flex: 1;
  min-width: 320px;
  display: flex;
  column-gap: 12px;
}

.healthTrend {
  flex: 1;
  min-width: 0;
}

.healthTrendTitle {
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 2px;
}

.healthVersions {
  max-height: 120px;
  overflow-y: auto;
}

.healthVersionsTable {
  border-collapse: collapse;
  font-size: 12px;
}

.healthVersionsTable th {
  text-align: left;
  font-weight: 500;
  color: var(--brown-grey);
  padding: 2px 16px 2px 0;
}

.healthVersionsTable td {
  padding: 3px 16px 3px 0;
  color: var(--black);
  border-top: solid 1px var(--very-light-pink);
}

.healthVersionName {
  font-weight: 500;
}

.loglyticsBody {
  margin-top: 8px;
  height: 132px;
}

.customTooltip {
  box-shadow: 0 1px 7px 0 #b2b2b2;
  background-color: var(--fully-white);
  padding: 15px;
  margin: 0 100px 0 100px;
  display: grid;
  grid-template-columns: max-content min-content max-content;
  align-items: center;
  z-index: 10000;
}

.customTooltipTitle {
  font-size: 12px;
  color: var(--marine);
  margin-bottom: 15px;
  text-align: center;
  grid-column: 1 / -1;
}

.customTooltipText {
  font-size: 12px;
  color: #b2b2b2;
}

.customTooltipColor {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin: 0 15px;
}

.customTooltipTotal {
  grid-column: 1 / -1;
  font-size: 12px;
  margin-top: 15px;
  font-weight: 500;
  text-align: center;
  color: var(--brown-grey);
}
